import EventDescription from '@/js/shared/components/info/EventDescription';
import WidgetWrapper from '@/js/shared/components/widgets/WidgetWrapper';
import { RoomContext } from '@/store';
import { INode, INodeProps } from '@/types/node';
import React, { useContext } from 'react';
import { IContent } from './contract';
import { Box } from '@mui/material';

interface INodeExtended extends Omit<INode, 'content'> {
  content: IContent;
}

interface IProps extends Omit<INodeProps, 'node'> {
  node: INodeExtended;
}

const useStyles = ({ override }: { override: Record<string, any> }) => ({
  root: {
    textAlign: 'left',
    ...override.root,
  },
});

export const Render = ({
  node: {
    id,
    content: { defaultText },
    override,
  },
  conferenceId,
}: IProps) => {
  const classes = useStyles({ override });

  const { roomState } = useContext(RoomContext); // Hämta Context

  return (
    <WidgetWrapper>
      <Box sx={classes.root}>
        {roomState.currentEvent ? (
          <EventDescription event={roomState.currentEvent} current={true} />
        ) : (
          defaultText
        )}
      </Box>
    </WidgetWrapper>
  );
};
